import { Component, OnInit, Input, ViewChild , OnDestroy} from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
 import { NgxSpinnerService } from 'ngx-spinner';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import {formatDate} from '@angular/common';
import { debounceTime,distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-auth-message',
  templateUrl: './auth-message.component.html',
  styleUrls: ['./auth-message.component.css']
})
export class AuthMessageComponent implements OnInit,OnDestroy {
  @ViewChild('attachInput') attachInputRef: any;
  @ViewChild('searchBox') searchBoxs:any;
  // private search = new Subject<string>();
    tooltip=`Supported Characters
    Alphabets
    Numbers
    Spaces
    Special Characters - _'-.# ,?\"$!@*:;%'`;
  messageSubscription: Subscription;
   sharedDoc: FormGroup;
   messageBusinessID;
   cp_business: any = {
     bp_business_id: '',
     name: ''
   };
   messages = [];
   profile_images = {};
  bussiness = '';
   aboutBusiness = 'All';
  supportedDocType = '';
  supporetsFiles = '';
  supportMaxFileSize = '';
  newMessage = '';
  message;
  listBiz = [];
  isLoading = false;
   AttachFiles = [];
   attachNames = [];
   bussinessList = [];
   addButton=false;
   searchBiz='';
   firstRun=true;
   listBizTotal=0;
   pageNo=1;
   count=1;
   supportedFile={
    maxSize:'',
    fileSize:0,
    type:''
  };
     constructor(public _apiService: ApiService,
    private spinner: NgxSpinnerService,
    private utils: UtilitiesService,
    private formBuilder: FormBuilder) {
      this.sharedDoc = this.formBuilder.group({
        business: [''],
        type: ['0']
      });
    }

  ngOnInit() {
    this.getSupportedFiles();
    this.messageSubscription = this.utils.curMessageBusinessID.subscribe((ID) => {
      this.messageBusinessID = ID;
      this.firstRun=true;
      this.pageNo=1;
      this.listBusiness();
    });
//  this.search.pipe(debounceTime(1000)).subscribe(x => this.searchAll());
 this.initOrderIdSearch(this.sharedDoc, 'business');

  }
  ngOnDestroy() {
    if (this.createOnlineSub) {
      this.createOnlineSub.unsubscribe();
    }    this.messageSubscription.unsubscribe();
  }
  initOrderIdSearch(form: FormGroup, formctrlName) {
    form.get(formctrlName).valueChanges
      .pipe(
        debounceTime(1000)
        , distinctUntilChanged()
      )
      .subscribe((value) => {
        if(value && typeof(value) == 'string'){
          this.getbussinessList(this.searchBiz);
          this.pageNo=1;
          this.listBusiness();
        }
      });
  }
  getbussinessList(search?) {
    const data = {
      bp_business_id: this.messageBusinessID
     };
     if(search){
      if (search.trim()) {
        data['query'] = search.trim();
      }
     }
    if(this.sharedDoc.value.type!='0'){
      data['filter_type'] = this.sharedDoc.value.type;
  }
    this._apiService.functionPOST('user/businessListForMessage', data).subscribe((response) => {
       this.bussinessList = response.data.list;
       this.spinner.hide();
    });
  }

  selectShareBusiness(business) {
    this.cp_business = {
      bp_business_id: business.option.value.bp_business_id,
      name: business.option.value.name
    };
     this.sharedDoc.patchValue({
      business: business.option.value.name
      });
      this.viewMessages();
  }
  viewMessages() {
    const apiObj = {
      bp_business_id: this.messageBusinessID,
      cp_bp_business_id: this.cp_business.bp_business_id,
      page: 1,
      limit: 10
    };
     this._apiService.functionPOST('message/listMessagesByBiz', apiObj).subscribe((response) => {
      this.messages = response['data']['data'];
      const userlist = [];
      this.messages.map((x) => {
        if (!userlist.includes(x.createdby)) {
          userlist.push(x.createdby);
          this.getProfilePhoto(x['createdby']);
        }
      });
     });
  }
  getProfilePhoto(data) {
    let addImage = true;
    if(Object.keys(this.profile_images).includes(data)){
      if(this.profile_images[data].includes('X-Amz-Date')) {
        let currDate = new Date()
        let expStr = this.profile_images[data].split('&').find(x => x.startsWith('X-Amz-Date')).split('=')[1];
        let expSecs = this.profile_images[data].split('&').find(x => x.startsWith('X-Amz-Expires')).split('=')[1];
        let newExpStr = expStr.substring(0, 4) + '-' + expStr.substring(4, 6) + '-' + expStr.substring(6, 11) + ':' +
          expStr.substring(11, 13) + ':' + expStr.substring(13, 16)
        let expDate = new Date(Date.parse(newExpStr));
        expDate.setSeconds(expDate.getSeconds() + +expSecs);
        addImage = currDate > expDate;
      } else {
        addImage = false
      }
    }
    if (addImage) {
      this.profile_images[data] = '';
      this._apiService.fileReader('user/getUserImagebyId', { um_user_id: data }).subscribe((response) => {
        this.profile_images[data] = this.utils.getImageURL(response);
       }, err => {});
    }
  }
  removeAttach(i) {
    this.AttachFiles.splice(i, 1);
     this.attachNames.splice(i, 1);
   }

   addFileComment(event: any) {
    for (let i = 0; i <= event.target.files.length - 1; i++) {

          const file = event.target.files[1];
          if (file) {
            const extn = file.name.split('.').pop();
                  if (this.supportedDocType.includes(extn.toLowerCase())) {
              if (file.size > this.supportedFile['fileSize']) {
                this._apiService.openSnackBar('Size should be less than '+this.supportedFile['maxSize'], 'Error');
                this.attachInputRef.nativeElement.value = '';
              return false;
              }
                  } else {
        this._apiService.openSnackBar('File not supported', 'Error');
         this.attachInputRef.nativeElement.value = '';
        return false;
      }
          }
      const selectedFile = event.target.files[i];
      this.AttachFiles.push(selectedFile);
      this.attachNames.push(selectedFile.name);
    }
    this.attachInputRef.nativeElement.value = '';
}

shareBizValue(e){
  this.searchBiz = e.target.value;
 }

  selectBusiness(item) {
     this.cp_business = {
      bp_business_id: item.cp_bp_business_id,
      name: item.cp_bp_business_name
    };

     this.viewMessages();
     if (item.count !== 0) {
       this.getMessageUnreadCountChange(item);
     }
  }
  getMessageUnreadCountChange(item){
    this.message.count = this.message.count - item.count;
    const find = this.message.unread_count_details.findIndex(y => y.cp_bp_business_id === item.cp_bp_business_id);
    this.message.unread_count_details[find].count = 0;
    this._apiService.messageCount = this.message;
    this.listBusiness('count');
  }
  getSupportedFiles() {
    this.utils.supportedUploadTypesData.subscribe(res => {
        if (res ) {
          const files   =  res['supported_file_types'];
          this.supportedDocType = files.split(',');
        }
        var size = (res['max_file_size_bytes']/1000000)+' MB';
        this.supportedFile={
          maxSize:size,
          fileSize:res['max_file_size_bytes'],
          type:res['supported_file_types']
        };
      this.supporetsFiles = '* Supported document types are ' + this.supportedFile['type'];
      this.supportMaxFileSize = '* Supported maximum file count is '+ res['max_file_count'] +
      ' and file size is ' + this.supportedFile['maxSize'];
    }
    );
  }

  addComment() {
    const apiData = new FormData();
   if (this.newMessage.trim() === '' || !this.newMessage) {
    this._apiService.openSnackBar('Please enter a comment', 'Error');
    this.addButton = false;
    return;
  }
  if (this.cp_business.bp_business_id === '' || this.cp_business.bp_business_id === null || this.cp_business.bp_business_id === undefined) {
    this._apiService.openSnackBar('Please select a business', 'Error');
    this.addButton = false;
    return;
  }
   this.addButton=true;
   apiData.append('sender_bp_business_id', this.messageBusinessID);
   apiData.append('recipient_bp_business_id', this.cp_business.bp_business_id);
   apiData.append('message',  btoa(unescape(encodeURIComponent(this.newMessage))));
   if (this.AttachFiles.length > 0) {
    this.AttachFiles.map((item) => {
      apiData.append('attachment', item);
    });
    //  apiData.append('attachment', this.AttachFiles);
   }

     this._apiService.functionPOST('message/send', apiData).subscribe((response) => {
       if (response.success) {
        this.addButton=false;
        this.newMessage = '';
        this._apiService.openSnackBar('Success', 'Success');
        this.sharedDoc.patchValue({'business': ''});
        this.AttachFiles = [];
        this.viewMessages();
        this.getbussinessList();
        this.pageNo=1;
        this.listBusiness();
      }
    });
  }
  createOnlineSub:Subscription;
  getMessageUnreadCount() {
    if(!this.messageBusinessID){
      return;
    }
    this.createOnlineSub = this._apiService.createOnline$().subscribe((status) => {
      if(status){
        if(this.messageBusinessID){
          const data = {
            bp_business_id: this.messageBusinessID
          };
           this._apiService.functionPOST('message/getMessageUnreadCount', data).subscribe((response) => {
             this._apiService.messageCount = response.data;
             this.message = response.data;
             this.listBusiness('count');
          });
        }
      }
    });
  }

  loadmore(){
    this.pageNo = this.pageNo+1;
    this.listBusiness();
  }
  listBusiness(str?) {
       if (!this.messageBusinessID) return;
     const apiObj = {
      bp_business_id: this.messageBusinessID,
      page: 1,
      limit: 100
    };
    if(this.sharedDoc.value.type!='0'){
      apiObj['filter_type'] = this.sharedDoc.value.type;
  }
  if(this.searchBiz){
    if (this.searchBiz.trim()) {
      apiObj['query'] = this.searchBiz.trim();
    }
  }

    this._apiService.functionPOST('message/listBiz', apiObj).subscribe((response) => {
      if(this.count < this.pageNo){
        this.count=this.count+1;
        this.listBiz = this.listBiz.concat(response.data.data);
      }else if(this.count==1 && this.pageNo==1){
        this.listBiz = response.data.data;
      }
      this.listBizTotal = parseInt(response.data.total);

      if(this.firstRun && this.listBiz.length==0){
        this.searchBoxs.nativeElement.focus();
     }
     this.firstRun=false;
      if (this.listBiz.length > 0 && this._apiService.messageCount['unread_count_details'].length > 0) {
        this.listBiz.map((x) => {
          this._apiService.messageCount['unread_count_details'].map((y) => {
            if (x.cp_bp_business_id === y['cp_bp_business_id']) {
              x.count = y['count'];
            }
          });
        });
      }

     if (str === 'count') {
      return;
    }
    if(this.sharedDoc.get('business').value  === ''){
      if (this.listBiz.length > 0) {
        this.cp_business = {
          bp_business_id: this.listBiz[0].cp_bp_business_id,
          name: this.listBiz[0].cp_bp_business_name
        };
        this.viewMessages();
      } else {
        this.cp_business = {
          bp_business_id: '',
          name: ''
        };
        this.messages = [];
      }
}
     });
  }

  downLoad(data) {
    const url = 'message/attachment/' + data['bp_message_attachment_id'];
    this._apiService.downloadNewFile(url);
  }
  radioButtonSelection(event) {
    this.pageNo=1;
    this.getbussinessList();
    this.listBusiness();
  }
  getDate(x){
    return(formatDate(new Date(x), 'yyyy-MM-dd', 'en'));
  }
  clearSearch(){
    this.sharedDoc.patchValue({
      "business":''
      });
      this.searchBiz='';
      this.pageNo=1;
      this.listBusiness();
   }
}
